import { useEffect, useState } from "react";
import type { IdxConsentProfile } from "../../config/idxConsentReceipts";
import { fetchIdxConsentProfile } from "../../services/idxConsentProfile";

interface ProfileState {
  organizationId: string | undefined;
  profile: IdxConsentProfile | null;
  loading: boolean;
}

/** Registration waits for the server's capture scope before choosing controls. */
export const useIdxConsentProfile = (organizationId: string | undefined) => {
  const [state, setState] = useState<ProfileState>({
    organizationId,
    profile: null,
    loading: Boolean(organizationId),
  });

  useEffect(() => {
    if (!organizationId) {
      setState({ organizationId, profile: null, loading: false });
      return;
    }
    const controller = new AbortController();
    setState({ organizationId, profile: null, loading: true });
    fetchIdxConsentProfile(organizationId, controller.signal)
      .then((profile) => {
        if (!controller.signal.aborted) {
          setState({ organizationId, profile, loading: false });
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          setState({ organizationId, profile: null, loading: false });
        }
      });
    return () => controller.abort();
  }, [organizationId]);

  if (state.organizationId !== organizationId) {
    return { profile: null, loading: Boolean(organizationId) };
  }
  return { profile: state.profile, loading: state.loading };
};
